/* City choices are rendered by Liquid. No API, index download or third-party code. */
(() => {
  'use strict';
  const initialize = (root) => {
    if (root.dataset.cityPickerReady) return;
    const dialog = root.querySelector('[data-city-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    root.dataset.cityPickerReady = 'true';
    const title = dialog.querySelector('[data-city-dialog-title]');
    const cities = dialog.querySelector('[data-city-list-panel]');
    const categoryPanel = dialog.querySelector('[data-city-category-panel]');
    const categoryContent = dialog.querySelector('[data-city-category-content]');
    const search = dialog.querySelector('[data-city-search]');
    const status = dialog.querySelector('[data-city-search-status]');
    const empty = dialog.querySelector('[data-city-empty]');
    const cityItems = Array.from(dialog.querySelectorAll('[data-city-list-item]'));
    const normalize = (text) => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();
    const templates = new Map(Array.from(root.querySelectorAll('[data-city-template]'), (template) => [template.dataset.cityTemplate, template]));
    let opener;
    let activeCity;
    const filterCities = () => {
      const query = normalize(search.value);
      let visible = 0;
      cityItems.forEach((item) => {
        item.hidden = !normalize(item.dataset.citySearchText || '').includes(query);
        if (!item.hidden) visible += 1;
      });
      empty.hidden = visible !== 0;
      status.textContent = `${visible} ${visible === 1 ? 'city' : 'cities'} available`;
    };
    const showCities = (focus = true) => {
      title.textContent = 'Choose your city';
      categoryPanel.hidden = true;
      cities.hidden = false;
      search.value = '';
      filterCities();
      dialog.scrollTop = 0;
      if (focus) {
        const previous = cityItems.map((item) => item.querySelector('[data-city-open]')).find((item) => item?.dataset.cityOpen === activeCity);
        (previous || search).focus();
      }
    };
    const open = (source) => {
      if (!dialog.open) {
        opener = source;
        dialog.showModal();
        document.documentElement.classList.add('city-picker-open');
      }
    };
    const showCity = (id, source) => {
      const template = templates.get(id);
      if (!template) return false;
      activeCity = id;
      title.textContent = `Places in ${template.dataset.cityName}`;
      cities.hidden = true;
      categoryPanel.hidden = false;
      categoryContent.replaceChildren(template.content.cloneNode(true));
      open(source);
      dialog.scrollTop = 0;
      title.focus();
      return true;
    };
    root.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const city = event.target.closest('[data-city-open]');
      if (city) {
        if (showCity(city.dataset.cityOpen, city)) event.preventDefault();
        return;
      }
      const all = event.target.closest('[data-city-show-all]');
      if (all) {
        event.preventDefault();
        activeCity = null;
        showCities(false);
        open(all);
        search.focus();
      }
    });
    search.addEventListener('input', filterCities);
    dialog.querySelector('[data-city-back]').addEventListener('click', () => showCities());
    dialog.querySelector('[data-city-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('[data-city-dialog][open]')) document.documentElement.classList.remove('city-picker-open');
      if (opener?.isConnected) opener.focus();
    });
    root.addEventListener('shopify:block:select', (event) => {
      if (!event.detail?.blockId) return;
      const source = Array.from(root.querySelectorAll('[data-city-open]')).find((item) => item.dataset.cityOpen === event.detail.blockId);
      if (source) showCity(event.detail.blockId, source);
    });
  };
  const mount = (scope) => {
    if (scope.matches?.('[data-city-picker]')) initialize(scope);
    scope.querySelectorAll('[data-city-picker]').forEach(initialize);
  };
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-city-dialog][open]').forEach((dialog) => dialog.close());
    if (!document.querySelector('[data-city-dialog][open]')) document.documentElement.classList.remove('city-picker-open');
  });
})();
